/**
 * Étape 4 — Catalogues UI pour les dossiers fiscaux (côté frontend uniquement).
 * Le backend reste permissif : ces listes ne sont pas validées en POST/PUT.
 */

export const INCOME_SOURCES = [
  { id: "T4",                   label: "T4 — Salaire" },
  { id: "T4A",                  label: "T4A — Revenus divers" },
  { id: "T5",                   label: "T5 — Revenus de placement" },
  { id: "T3",                   label: "T3 — Fiducie" },
  { id: "RL-1",                 label: "RL-1 — Relevé d'emploi (QC)" },
  { id: "travailleur_autonome", label: "Travailleur autonome / TP-80" },
  { id: "locatif",              label: "Revenus locatifs" },
  { id: "capital",              label: "Gains en capital" },
  { id: "pension",              label: "Pension / Régime de retraite" },
  { id: "etranger",             label: "Revenus de l'étranger" },
];

export const DEDUCTION_SOURCES = [
  { id: "REER",                 label: "REER" },
  { id: "FTQ",                  label: "FTQ / Fondaction" },
  { id: "frais_medicaux",       label: "Frais médicaux" },
  { id: "frais_garde",          label: "Frais de garde" },
  { id: "frais_demenagement",   label: "Frais de déménagement" },
  { id: "frais_emploi",         label: "Frais d'emploi (T2200)" },
  { id: "dons",                 label: "Dons de bienfaisance" },
  { id: "interets_etudes",      label: "Intérêts sur prêts étudiants" },
  { id: "pension_alimentaire",  label: "Pension alimentaire" },
  { id: "aidant_naturel",       label: "Crédit aidant naturel" },
];
